import * as setup from '@/setup';
import Button from '@/objects/button';

/**
 * Crea uno sfondo tabella con grafica (senza PNG)
 * @param {Phaser.Scene} scene - La scena Phaser
 * @param {number} centerX - Posizione X del centro della tabella
 * @param {number} centerY - Posizione Y del centro della tabella
 * @param {number} width - Larghezza della tabella (default: 600)
 * @param {number} height - Altezza della tabella (default: 500)
 * @param {number} headerHeight - Altezza dell'header (default: 60)
 * @param {number} cornerRadius - Raggio degli angoli arrotondati (default: 20)
 * @returns {Object} Oggetto con i riferimenti alle grafiche create
 */
export var createTableBackground = (scene, centerX, centerY, width = 600, height = 500, headerHeight = 60, cornerRadius = 20) => {
	const shadowOffset = 4;
	
	// Colori
	const headerColor = 0x2C6B9B; // Blu header
	const bodyColor = 0xFFFFFF; // Bianco corpo
	const shadowColor = 0xD0D0D0; // Grigio ombra
	
	// Crea l'ombra (leggermente spostata in basso e a destra)
	const shadowGraphics = scene.add.graphics();
	shadowGraphics.fillStyle(shadowColor, 0.3);
	shadowGraphics.fillRoundedRect(
		centerX - width / 2 + shadowOffset,
		centerY - height / 2 + shadowOffset,
		width,
		height,
		cornerRadius
	);
	
	// Crea il corpo bianco del popup
	const bodyGraphics = scene.add.graphics();
	bodyGraphics.fillStyle(bodyColor, 1);
	bodyGraphics.fillRoundedRect(
		centerX - width / 2,
		centerY - height / 2,
		width,
		height,
		cornerRadius
	);
	
	// Crea l'header blu (solo la parte superiore con angoli arrotondati in alto)
	const headerGraphics = scene.add.graphics();
	headerGraphics.fillStyle(headerColor, 1);
	// Header con angoli arrotondati solo in alto
	headerGraphics.fillRoundedRect(
		centerX - width / 2,
		centerY - height / 2,
		width,
		headerHeight,
		cornerRadius
	);
	// Copri gli angoli inferiori dell'header per renderli quadrati
	headerGraphics.fillRect(
		centerX - width / 2,
		centerY - height / 2 + headerHeight - cornerRadius,
		width,
		cornerRadius
	);
	
	// Aggiungi un leggero highlight/blur in alto sull'header per effetto glossy
	const highlightGraphics = scene.add.graphics();
	highlightGraphics.lineStyle(2, 0x4A8FC7, 0.3); // Blu più chiaro per highlight
	highlightGraphics.strokeRoundedRect(
		centerX - width / 2 + 1,
		centerY - height / 2 + 1,
		width - 2,
		headerHeight - 1,
		cornerRadius
	);
	
	return {
		shadow: shadowGraphics,
		body: bodyGraphics,
		header: headerGraphics,
		highlight: highlightGraphics
	};
};

/**
 * Divide il testo in righe di massimo maxChars caratteri
 * @param {string} text - Il testo da dividere
 * @param {number} maxChars - Numero massimo di caratteri per riga
 * @returns {string} Testo con a capo inseriti
 */
var wrapText = (text, maxChars) => {
	var words = text.split(' ');
	var lines = [];
	var currentLine = '';

	for (var i = 0; i < words.length; i++) {
		var word = words[i];
		var testLine = currentLine ? currentLine + ' ' + word : word;

		if (testLine.length <= maxChars) {
			currentLine = testLine;
		} else {
			if (currentLine) {
				lines.push(currentLine);
			}
			currentLine = word;
		}
	}

	if (currentLine) {
		lines.push(currentLine);
	}

	return lines.join('\n');
};

export var drawGameOverScene = (scene, icon, textLabel) => {
	// aggiungi layer trasparente
	scene.add
		.graphics()
		.lineStyle(setup.styles.backgroundDitloide)
		.fillRect(0, 0, scene.sys.game.config.width, scene.sys.game.config.height)
		.setAlpha(0.5);

	// aggiungi sfondo - ingrandito per avere più spazio
	scene.add.image(scene.sys.game.config.width / 2, scene.sys.game.config.height / 2, icon).setScale(0.7);

	// mostra bottone gioca ancora - spostato più in alto di 10 pixel
	let buttonPlay = new Button(
		scene,
		scene.sys.game.config.width / 2.8,
		scene.sys.game.config.height / 2 + setup.margin.buttonPlayMarginTop + 180 - 10,
		'green-button',
		0.4,
		setup.labels.playAgain
	);

	// mostra bottone esci - spostato più in alto di 10 pixel
	let buttonQuit = new Button(
		scene,
		scene.sys.game.config.width / 1.6,
		scene.sys.game.config.height / 2 + setup.margin.buttonPlayMarginTop + 180 - 10,
		'red-button',
		0.4,
		setup.labels.quit
	);

	// mostra testo popup (solo il titolo, il punteggio verrà mostrato dall'animazione)
	// Spostato più in basso per non sovrapporsi all'icona
	if (textLabel) {
		// Per testi lunghi (soluzione ditloide), usa word wrap
		var maxCharsPerLine = 35;
		var isLongText = textLabel.length > maxCharsPerLine;
		var displayText = isLongText ? wrapText(textLabel, maxCharsPerLine) : textLabel;
		// Usa stessa dimensione di "Punteggio finale" (32px) e colore arancione vivace
		var fontSize = 32;
		var textColor = '#FF6B35';

		scene.add
			.text(
				scene.sys.game.config.width / 2,
				scene.sys.game.config.height / 2 - 80,
				displayText,
				{...setup.styles.gameOver.greetingStyle, fontSize: fontSize, fill: textColor}
			)
			.setOrigin(0.5);
	}

	return { buttonPlay, buttonQuit };
};
